import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Polo Shirt",
    description: "Van Heusen Men's Regular Fit Polo Shirt",
    url:"https://m.media-amazon.com/images/I/71mabojWcsL._UX466_.jpg",
    rating:3.9,
    price: 1000,
    discount:55,
    size:'M',
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Cotton Kurta with Palazzo Set",
    description: "Ethnic Motifs Embroidered Sequined Kurta with Palazzos",
    url:"https://m.media-amazon.com/images/I/51ITkdswJFL._UL1500_.jpg",
    rating:4.5,
    price: 999,
    discount:25,
    size:'M',
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "Printed Straight Kurta",
    description: "Amayra Men's Cotton Printed Straight Kurta",
    url:"https://m.media-amazon.com/images/I/71G1BdaZzJL._UL1500_.jpg",
    rating:4.9,
    price: 1399,
    discount:28,
    size:'L',
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "Floral Jumpsuit for Girls",
    description: "Arshia Fashions Knee Length Cotton Floral Jumpsuit",
    url:"https://m.media-amazon.com/images/I/915Z4E-SIvL._UL1500_.jpg",
    rating:3.2,
    price: 1000,
    discount:40,
    size:"S",
    categoryName: "Juniors",
  },
  {
    _id: uuid(),
    title: "T-Shirt with Denim Shorts",
    description: "Googo Gaaga Boy's Cotton Printed T-Shirt",
    url:"https://m.media-amazon.com/images/I/51z0B0H2wLL.jpg",
    rating:3,
    price: 999,
    discount:10,
    size:"XL",
    categoryName: "Juniors",
  },
  {
    _id: uuid(),
    title: "Short A-Line Dress",
    description: "Leriya Fashion Western Dresses for Women",
    url:"https://m.media-amazon.com/images/I/713EWcF36KL._UL1500_.jpg",
    rating:4,
    price: 1799,
    discount:60,
    size:"S",
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "Cargo Trousers",
    description: "Broadstar Women High-Rise,Straight Fit trouser",
    url:"https://m.media-amazon.com/images/I/31XO1-rezAL.jpg",
    rating:5,
    price: 1499,
    discount:50,
    size:"L",
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "DHRUVI TRENDZ Shirt",
    description: "Tropical Leaf Printed Shirt for Men,with turn down collar.",
    url:"https://m.media-amazon.com/images/I/519yrZ9qILL.jpg",
    rating:2.5,
    price: 1299,
    discount:35,
    size:"S",
    categoryName: "Men",
  },
  {
    _id: uuid(),
    title: "T-Shirt For Girl's",
    description: "Cherokee by Unlimited Girl's Regular T-Shirt",
    url:"https://m.media-amazon.com/images/I/71coy-sc6UL._UL1500_.jpg",
    rating:1.2,
    price: 2000,
    discount:30,
    size:"L",
    categoryName: "Juniors",
  },
  {
    _id: uuid(),
    title: "Oversized T-Shirt",
    description: "CALM DOWN Drop Shoulder T-Shirt for Women",
    url:"https://m.media-amazon.com/images/I/61q-DoKtFpL._UL1490_.jpg",
    rating:3,
    price: 1299,
    discount:30,
    size:"XL",
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "Casual Pants",
    description: "Amazon Brand - Symbol Men Regular Casual Pants",
    url:"https://m.media-amazon.com/images/I/71rQD1ndKpL._UL1500_.jpg",
    rating:3.5,
    price: 1599,
    discount:25,
    size:"XL",
    categoryName: "Men",
  },{
    _id: uuid(),
    title: "Cotton Kid's T-Shirt",
    description: "Bold N Elegant Half Sleeve Cotton Kid's T-Shirt",
    url:"https://m.media-amazon.com/images/I/61M0jzflioL._UL1018_.jpg",
    rating:2.9,
    price: 2500,
    discount:30,
    size:"M",
    categoryName: "Juniors",
  },{
    _id: uuid(),
    title: "Floral Printed Kurta",
    description: "GoSriKi Women's Rayon Kurta with Pants & Dupatta",
    url:"https://m.media-amazon.com/images/I/815QW8bkthL._UX569_.jpg",
    rating:3.4,
    price: 1500,
    discount:15,
    size:"S",
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: "A-Line Maxi Dress",
    description: "Lymio Women's Rayon A-Line Maxi Dress",
    url:"https://m.media-amazon.com/images/I/71YCvqdQn1L._UY679_.jpg",
    rating:4.9,
    price: 1020,
    discount:30,
    size:"M",
    categoryName: "Women",
  },
  {
    _id: uuid(),
    title: " Boy's Cotton Pocket T-Shirt",
    description: "Googogaaga Boy's T-Shirt With Short",
    url:"https://m.media-amazon.com/images/I/51KKESbET1L._UX522_.jpg",
    rating:1.2,
    price: 999,
    discount:10,
    size:"XL",
    categoryName: "Juniors",
  },
  {
    _id: uuid(),
    title: "Men's Cotton Printed ",
    description: "rytras Men's Cotton Peach Printed Straight Kurta",
    url:"https://m.media-amazon.com/images/I/71HIAY6U0+L._UY606_.jpg",
    rating:5,
    price: 1299,
    discount:45,
    size:"L",
    categoryName: "Men",
  },
];
